import { NumericChange } from '../../Attribute';
import { AttributeValueInstance, AttributeValueOrNumber } from '../AttributeValueInstances/AttributeValueInstance';
import { AttributeInstance } from './AttributeInstance';

export class NumericChangeInstance extends AttributeInstance<NumericChange> {
  constructor(attribute: NumericChange) {
    super(attribute);
  }

  public override setAttributeValue(attributeValue: AttributeValueOrNumber) {
    if (typeof attributeValue === 'number') {
      const currentValue = this._setAttributeValue?.attributeValue;

      if (currentValue !== undefined && typeof currentValue === 'number' && currentValue === attributeValue) {
        return undefined;
      }
      this._setAttributeValue = new AttributeValueInstance<number>(attributeValue);
      return this._setAttributeValue?.attributeWasSet$ ? this._setAttributeValue?.attributeWasSet$ : true;
    }
    return undefined;
  }
}
